module.exports = __webpack_public_path__ + "assets/fonts/9e4b71d521e971525937b4cc3a6206ad.png";